import { AxiosResponse } from 'axios'
import { http } from '@/core/realisations/Http.realisation'

import {
    GetDispatcherSectorsParams,
    GetDispatcherSectorsResponse,
    DispatcherSectorFormPayload,
} from './types/dispatcher-sectors'
import { CreateExpressZonePayload, GetExpressZonesParams, GetExpressZonesResponse, GetExpressZoneTypesParams, GetExpressZoneTypesResponse, UpdateExpressZonePayload } from './types/sectors'

type ApiGetDispatcherSectorsResponse = Promise<AxiosResponse<GetDispatcherSectorsResponse>>
type ApiCreateDispatcherSectorResponse = Promise<AxiosResponse<void>>
type ApiUpdateDispatcherSectorResponse = Promise<AxiosResponse<void>>
type ApiDeleteDispatcherSectorResponse = Promise<AxiosResponse<void>>
type ApiSetExtendedCoordinateResponse = Promise<AxiosResponse<void>>

type ApiGetExpressZonesResponse = Promise<AxiosResponse<GetExpressZonesResponse>>
type ApiGetExpressZoneTypesResponse = Promise<AxiosResponse<GetExpressZoneTypesResponse>>
type ApiCreateExpressZoneResponse = Promise<AxiosResponse<void>>
type ApiUpdateExpressZoneResponse = Promise<AxiosResponse<void>>
type ApiDeleteExpressZoneResponse = Promise<AxiosResponse<void>>

export function getDispatcherSectors(
    params: GetDispatcherSectorsParams
): ApiGetDispatcherSectorsResponse {
    return http.get('/dispatcher/api/dispatcher-sectors', { params })
}

export function getAllDispatcherSectors(name?: string): ApiGetDispatcherSectorsResponse {
    const params = {
        name,
    }

    return http.get('/dispatcher/api/dispatcher-sectors/all', { params })
}

export function createDispatcherSector(
    payload: DispatcherSectorFormPayload
): ApiCreateDispatcherSectorResponse {
    return http.post('/dispatcher/api/dispatcher-sectors', payload)
}

export function updateDispatcherSector(
    dispatcher_sector_id: number,
    payload: DispatcherSectorFormPayload
): ApiUpdateDispatcherSectorResponse {
    return http.put(`/dispatcher/api/dispatcher-sectors/${dispatcher_sector_id}`, payload)
}

export function deleteDispatcherSector(
    dispatcher_sector_id: number
): ApiDeleteDispatcherSectorResponse {
    return http.delete(`/dispatcher/api/dispatcher-sectors/${dispatcher_sector_id}`)
}

export function setExtendedCoordinate(dispatcher_sector_id: number, coordinates: number[][]): ApiSetExtendedCoordinateResponse {
    return http.put(`/dispatcher/api/dispatcher-sectors/${dispatcher_sector_id}/set-extended-coordinate`, {
        extendedCoordinates: coordinates
    })
}

export function getExpressZones(params: GetExpressZonesParams): ApiGetExpressZonesResponse {
    return http.get('/dispatcher/api/express-zones', { params })
}

export function createExpressZone(payload: CreateExpressZonePayload): ApiCreateExpressZoneResponse {
    return http.post('/dispatcher/api/express-zones', payload)
}

export function updateExpressZone(expressZoneId: number, payload: UpdateExpressZonePayload): ApiUpdateExpressZoneResponse {
    return http.put(`/dispatcher/api/express-zones/${expressZoneId}`, payload)
}

export function deleteExpressZone(expressZoneId: number): ApiDeleteExpressZoneResponse {
    return http.delete(`/dispatcher/api/express-zones/${expressZoneId}`)
}

export function getExpressZoneTypes(params: GetExpressZoneTypesParams): ApiGetExpressZoneTypesResponse {
    return http.get('/dispatcher/api/express-zone-types', { params })
}

export default {
    getDispatcherSectors,
    getAllDispatcherSectors,
    createDispatcherSector,
    updateDispatcherSector,
    deleteDispatcherSector,
    setExtendedCoordinate,
    getExpressZones,
    createExpressZone,
    updateExpressZone,
    deleteExpressZone,
    getExpressZoneTypes
}
